import * as React from "react";

import { InputNumber  } from "antd";

function ProductInputNumber(props) {
  const { productInfo, setProductInfo } = props;
  const { step, field } = props;
  const { errorField, setErrorField } = props;
  const { disabled, min, max, formatter, parser } = props;
  return (
    <div style={{ textAlign: "left", marginBottom: 0 }}>
      <InputNumber
        style={{
          border: errorField !== undefined && errorField.includes(field)
            ? "1px solid red"
            : "1px solid #d9d9d9",
          borderRadius: "8px",
          background: `var(--backgroundColor)`,
          padding: "4px 12px",
          width: "100%"
        }}
        value={
          productInfo === undefined || productInfo[field] == undefined ? "0" : productInfo[field]
        }
        defaultValue ={ productInfo === undefined || productInfo[field] == undefined ? "0" : productInfo[field]}
        disabled={disabled === undefined ? false : disabled}
        formatter={formatter === undefined ?  "": formatter}
        parser={parser === undefined ?  "": parser}
        
        min={min === undefined ? "0" : min}
        max={max === undefined ? "100000000" : max}
        step={step === undefined ? "1" : step}
        onChange={(value) => {
          var info = productInfo;
          info[field] = value;
          if (errorField !== undefined && errorField.includes(field)) {
            var errors = errorField.filter((x) => x != field);
            // console.log(errors);
            setErrorField([...errors]);
          }
          setProductInfo({ ...info });
        }}
      />
    </div>
  );
}

export default ProductInputNumber;
